import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import {   NavParams,Nav } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { ApiUserProvider } from '../../providers/api-user/api-user';
import { ListPage } from '../list/list';


import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';
//import { HTTP } from '@ionic-native/http/ngx';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';

import { DoctorPage } from '../../pages/doctor/doctor';
import { NursePage } from '../../pages/nurse/nurse';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  nav: Nav;
  PasswordVal:string;
  NameVal:string;
  list: Array<any>=[];
  
  constructor(public navCtrl: NavController,public apiUserProvider:ApiUserProvider,
     public navParams: NavParams,private storage: Storage
    ,private http:Http
    ,public alertCtrl: AlertController,public loadingCtrl: LoadingController) {
           
  }

  save(){

    let loader = this.loadingCtrl.create({
      content: "Please wait...",
      //duration: 3000,
    });
    loader.present();
    this.http.get(this.apiUserProvider.MyDomain+'/api/Default/GetDoctorInfo/'
    +this.NameVal+'-'+this.PasswordVal)
    .map(res => res.json()).subscribe(data => {         
         this.list = data;
        //let Loged:boolean=false;
        if(this.list !== undefined && this.list.length>0)
        {
          //Loged=true;
          this.apiUserProvider.ISDoctor=true;
          this.apiUserProvider.USerial=this.list[0].DISerial;
          this.apiUserProvider.UFullName=this.list[0].DIName;
          this.storage.set('name', this.NameVal);
          this.storage.set('ISDoctor', '1');
          this.storage.set('USerial', this.list[0].DISerial);
          this.storage.set('UFullName', this.list[0].DIName);
          this.apiUserProvider.UName=this.NameVal;       
          this.navCtrl.setRoot( DoctorPage); 
        }
        else{
          this.http.get(this.apiUserProvider.MyDomain+'/api/Default/GetNurseInfo/'
          +this.NameVal+'-'+this.PasswordVal)
          .map(res => res.json()).subscribe(data2 => { 
            this.list = data2;  
         
            if(this.list !== undefined && this.list.length>0)
     {
      this.apiUserProvider.ISDoctor=false;
      this.apiUserProvider.USerial=this.list[0].NISerial;
      this.apiUserProvider.UFullName=this.list[0].NIName;
      this.storage.set('name', this.NameVal);
      this.storage.remove('ISDoctor');
      this.storage.set('USerial', this.list[0].NISerial);
      this.storage.set('UFullName', this.list[0].NIName);
      this.apiUserProvider.UName=this.NameVal;       
      this.navCtrl.setRoot( NursePage); 
     }
     else
     {
       const alert = this.alertCtrl.create({
         title: 'رسالة خطأ',
         subTitle: 'تاكد من البيانات',
         buttons: ['OK']
       }); 
       alert.present();
     }
      
     });

        }
        
     
     
    loader.dismiss();
},err => {
console.log(err);
loader.dismiss();
const alert = this.alertCtrl.create({
 title: 'Error message',
 subTitle: err,
 buttons: ['OK']
});
alert.present();
});




   
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts